// SPDX-License-Identifier: MIT
// Helper for reading the first N bytes of a Blob with environment feature detection.

export interface BlobHeadResult {
  head: string; // decoded textual head (may be placeholder)
  placeholder: boolean; // true if environment produced a non-spec placeholder (e.g. '[object Blob]')
  bytesRead: number; // number of characters in head string
}

let envChecked = false;
let envBroken = false;

async function environmentCheck(): Promise<void> {
  if (envChecked) return;
  envChecked = true;
  try {
    const sample = new Blob(['__AV_BLOB_TEST__']);
    const ab = await sample.arrayBuffer();
    const text = new TextDecoder().decode(new Uint8Array(ab));
    envBroken = text !== '__AV_BLOB_TEST__';
  } catch {
    envBroken = true;
  }
}

export async function readBlobHead(blob: Blob, bytes = 200): Promise<BlobHeadResult> {
  await environmentCheck();
  let head = '';
  let placeholder = false;
  try {
    const ab = await blob.arrayBuffer();
    head = new TextDecoder().decode(new Uint8Array(ab).slice(0, bytes));
  } catch {
    try {
      head = (await new Response(blob).text()).slice(0, bytes);
    } catch {
      head = '';
    }
  }
  if (envBroken && head.startsWith('[object Blob]')) {
    placeholder = true;
  }
  return { head, placeholder, bytesRead: head.length };
}

export function isBlobDecodingBroken(): boolean {
  return envBroken;
}
